import { Navigate, useParams } from 'react-router-dom';
import {GameContext, GameProvider} from '../../../contexts/GameContext';
import GameLobbyComponents from './GameLobbyComponents';
import { useEffect, useState, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { AppClient } from '../../../HttpClient/AppClient';

const GameLobby = () => {
    const { gameid } = useParams();
    const gameContext = useContext(GameContext);

    const [isLoading, setIsLoading] = useState(true);
    const [gameExists, setGameExists] = useState<boolean | null>(null);

    useEffect(() => {
        const checkGameExists = async () => {

            const result = await AppClient.CheckGameExists(gameid as string);

            setGameExists(result.success);

            setIsLoading(false);
        };

        checkGameExists();
    }, [gameContext.gameId]);


    if (isLoading || gameExists == null) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    color: 'white'
                }}
            >
                <Typography variant="h6">Loading...</Typography>
            </Box>
        );
    }

    return gameExists ? (
       <GameLobbyComponents gameId={gameid as string} />
    ) : (
        <Navigate to="/" />
    );
};

export default GameLobby;
